import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { ClusterManagement } from './api/clusterManagementClient';
import { clusterManagementApiRef } from './api/types';
import {
  clusterAppDetailRouteRef,
  clusterAppRouteRef,
  clusterRouteRef,
} from './routes';
import { DEPLOYMENT_STATUS_FF } from './constants';

export const clusterManagementPlugin = createPlugin({
  id: 'cluster-management',
  apis: [
    createApiFactory({
      api: clusterManagementApiRef,
      deps: {
        identityApi: identityApiRef,
        configApi: configApiRef,
      },
      factory: ({ identityApi, configApi }) =>
        new ClusterManagement({ identityApi, configApi }),
    }),
  ],
  routes: {
    entityContent: clusterRouteRef,
  },
  featureFlags: [
    {
      name: DEPLOYMENT_STATUS_FF,
    },
  ],
});

export const EnvManagementEnvironmentsPage = clusterManagementPlugin.provide(
  createRoutableExtension({
    name: 'EnvManagementEnvironmentsPage',
    component: () =>
      import('./components/EnvManagementEnvironmentsPage').then(
        m => m.EnvManagementEnvironmentsPage,
      ),
    mountPoint: clusterRouteRef,
  }),
);

export const EnvManagementApplicationsPage = clusterManagementPlugin.provide(
  createRoutableExtension({
    name: 'EnvManagementApplicationsPage',
    component: () =>
      import('./components/EnvManagementApplicationsPage').then(
        m => m.EnvManagementApplicationsPage,
      ),
    mountPoint: clusterRouteRef,
  }),
);

export const AppManagementPage = clusterManagementPlugin.provide(
  createRoutableExtension({
    name: 'AppManagementPage',
    component: () =>
      import('./components/AppManagementPage').then(m => m.AppManagementPage),
    mountPoint: clusterAppRouteRef,
  }),
);

export const AppManagementClusterPage = clusterManagementPlugin.provide(
  createRoutableExtension({
    name: 'AppManagementClusterPage',
    component: () =>
      import('./components/AppManagementClusterPage').then(
        m => m.AppManagementClusterPage,
      ),
    mountPoint: clusterAppDetailRouteRef,
  }),
);
